enum TabOrWidgetEnum {
    Tab = 0,
    Widget = 1,
}

enum KeyReportStubTypeEnum {
    Design = "Design",
    Templates = "Templates",
}
enum NewReportStubTypeEnum {
    Report = -9999,
    Chart = -9998,
    Pivot = -9997,
    Empty = -9996
}

enum FontAlignmentEnum {
    Start = 0,
    Center = 1,
    End = 2
}

enum WidgetType {
    Report = 0,
    Chart = 2,
    Pivot = 3,
    RichText = 1,
    KPI = 4,
    None = 5,
    Filter = 6,
    TreeMap = 7,
    Map = 8,
    Gauge = 9,
    Funnel = 10,
}

enum UpdateSettingMode {
    Automatic,
    Reload,
    Setup,
    Repaint,
    Custom
}

enum WorkbookEditModeEnum {
    ViewOnly,
    Owner,
    EditBySharedUser,
    Restricted
}

enum FieldMetricSettingsValueChangeTypeEnum {
    Before,
    After
}

enum ColumnFieldsTextPivotEnum {
    Automatic,
    LineBreak,
    Concatenate
}